










import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ContractHistoryTimelineItem extends Vue {
  @Prop({
    required: false,
    default: 'white',
  })
  private color!: string;

  @Prop({
    required: false,
    default: true,
  })
  private fillDot!: boolean;

  @Prop({
    required: false,
    default: 'mdi-bell-ring',
  })
  private icon!: string;

  @Prop({
    required: false,
    default: '#BDBDBD',
  })
  private iconColor!: string;
}
